import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./legal-pages.css";

/**
 * Wrapper for Privacy Policy and Terms of Use (public site layout).
 * Body copy follows the active locale (English or Arabic).
 */
export default function LegalPageShell({ titleKey, children }) {
  const { t, i18n } = useTranslation();
  const lastUpdated = t("legal.lastUpdatedDate");
  const pageTitle = t(titleKey);
  const isAr = (i18n.language || "").toLowerCase().startsWith("ar");
  const lang = isAr ? "ar" : "en";
  const dir = i18n.dir();

  useEffect(() => {
    const prev = document.title;
    document.title = `${pageTitle} · VizHacks`;
    return () => {
      document.title = prev;
    };
  }, [pageTitle]);

  return (
    <article
      className={`legal-page legal-page--full legal-page--${lang}`}
      dir={dir}
      lang={lang}
    >
      <div className="legal-page__inner container-n">
        <nav className="legal-page__nav" aria-label={t("legal.breadcrumbLabel")}>
          <Link className="legal-page__back" to="/">
            <span className="legal-page__back-arrow" aria-hidden="true">
              {isAr ? "→" : "←"}
            </span>
            {t("legal.backHome")}
          </Link>
        </nav>

        <header className="legal-page__header">
          <h1 className="legal-page__title">{t(titleKey)}</h1>
          <p className="legal-page__meta">
            {t("legal.lastUpdated")} {lastUpdated}
          </p>
        </header>

        <div className="legal-page__body" dir={dir} lang={lang}>
          {children}
        </div>
      </div>
    </article>
  );
}
